import { db } from '../firebase';
import { collection, writeBatch, doc, serverTimestamp } from 'firebase/firestore';
import { getPendingAllocations, calculateAllocations, saveAllocationsToDb, UnifiedTip, verifyPOSImport } from './allocationService';
import { getSettings } from './settingsService';
import { auth } from '../firebase';

enum OperationType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  LIST = 'list',
  GET = 'get',
  WRITE = 'write',
}

function handleFirestoreError(error: unknown, operationType: OperationType, path: string | null) {
  const errInfo = {
    error: error instanceof Error ? error.message : String(error),
    authInfo: {
      userId: auth.currentUser?.uid,
      email: auth.currentUser?.email,
      emailVerified: auth.currentUser?.emailVerified,
    },
    operationType,
    path
  }
  console.error('Firestore Error: ', JSON.stringify(errInfo));
  throw new Error(JSON.stringify(errInfo));
}

export const approveTipAllocation = async (tenantId: string, managerEmail: string): Promise<number> => {
  try {
    const pendingTips = await getPendingAllocations(tenantId);
    if (pendingTips.length === 0) return 0;

    const settings = await getSettings(tenantId);
    
    // Verify POS data exists for all tip dates being approved based on setting
    if (settings?.usePosShiftDataForActuals !== false) {
      const contexts = pendingTips.map(t => ({ date: t.tipDate, shift: t.shift }));
      const posVerification = await verifyPOSImport(tenantId, contexts);
      const missingPOS = posVerification.filter(v => !v.hasPOS);
      if (missingPOS.length > 0) {
        throw new Error(`POS data is missing for: ${missingPOS.map(m => `${m.date}${m.shift ? ` (shift: ${m.shift})` : ''}`).join(', ')}. Please import POS tips first.`);
      }
    }

    const allocatedTips = await calculateAllocations(tenantId, pendingTips);
    
    await saveAllocationsToDb(tenantId, allocatedTips, pendingTips);
    
    return allocatedTips.length;
  } catch (error) {
    handleFirestoreError(error, OperationType.WRITE, 'tenants/' + tenantId + '/master_transactions');
    return 0;
  }
};
